namespace advisorop.constants {
    // localstorage keys
    export const LS_LOV: string = "lovs";
    export const LS_VERSION: string = "version";
    export const LS_LOV_VERSION: string = "lov_version";

    // other constants 
    export const DEFAULT_VERSION: string = "0.0.0";

    export const WORKFLOW_CONNECTOR: string = "connector"
    export const WORKFLOW_PROCESS: string = "aoprocess"
    export const WORKFLOW_DECISION: string = "aodecision"
    export const WORKFLOW_TERMINATOR: string = "terminator"
}